import { render, staticRenderFns } from "./CertificateInfo.vue?vue&type=template&id=2631fecd&scoped=true"
import script from "./CertificateInfo.vue?vue&type=script&lang=js"
export * from "./CertificateInfo.vue?vue&type=script&lang=js"
import style0 from "./CertificateInfo.vue?vue&type=style&index=0&id=2631fecd&prod&lang=stylus&scoped=true"
import style1 from "./CertificateInfo.vue?vue&type=style&index=1&id=2631fecd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2631fecd",
  null
  
)

export default component.exports